import React from 'react';

const Header = ({ logoUrl }) => (
  <div className="walkthrough-header">
    <a className="logo" href="/">
      <img src={logoUrl} alt="Statuspage Logo" />
      <span className="bep">Better Error Pages</span>
    </a>
    <span className="powered-by"><a href="http://statuspage.io/powered-by" target="_blank" rel="noopener noreferrer nofollow">Powered by Statuspage</a></span>
  </div>
);

module.exports = Header;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/header.jsx